import React from 'react';
import { SketchPicker } from 'react-color';
import Modal from '../../Components/Modal';
import Button from '../../Components/Button';
import { Droplet } from '../../Components/Icon';

type Props = {
    color?: string;
    onChange: (value: string) => void;
};

function ColorSelector({ color = 'transparent', onChange }: Props) {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                className="h-10 w-10 rounded-xl border border-slate-200 p-0 shadow-none"
                style={{ backgroundColor: color }}
            >
                <span className="flex h-full w-full items-center justify-center rounded-[11px] border border-black/5 bg-white/20">
                    <Droplet className="h-4 w-4 text-slate-600 mix-blend-multiply" />
                </span>
            </Button>
            {open && (
                <Modal
                    open={open}
                    close={() => setOpen(false)}
                    className="max-w-xs flex justify-center py-8"
                >
                    <SketchPicker
                        color={color}
                        onChangeComplete={(e: { hex: string }) => {
                            onChange(e.hex);
                            setOpen(false);
                        }}
                    />
                </Modal>
            )}
        </>
    );
}

export default ColorSelector;
